import FAQSectionI18n from "@/components/landing/shared/FAQSectionI18n";
const FAQVerbaendeSection = () => <FAQSectionI18n translationPrefix="industryVerbaende" bgClass="bg-secondary/30" />;
export default FAQVerbaendeSection;
